import * as React from "react"
import type { SVGProps } from "react"
const SvgCartPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 7H9a1 1 0 0 1-.71-.29A1 1 0 0 1 8 6q0-.42.29-.71.29-.3.71-.29h2V3q0-.42.29-.71.29-.3.71-.29.42 0 .71.29.3.29.29.71v2h2q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29h-2v2q0 .42-.29.71-.29.3-.71.29a1 1 0 0 1-.71-.29A1 1 0 0 1 11 9zM5.59 22.41Q4.99 21.82 5 21q0-.83.59-1.41.59-.6 1.41-.59.82 0 1.41.59.6.59.59 1.41 0 .83-.59 1.41-.59.6-1.41.59-.82 0-1.41-.59m10 0q-.6-.59-.59-1.41 0-.83.59-1.41.58-.6 1.41-.59.83 0 1.41.59.6.59.59 1.41 0 .83-.59 1.41-.59.6-1.41.59-.83 0-1.41-.59M3 5H2a1 1 0 0 1-.71-.29A1 1 0 0 1 1 4q0-.42.29-.71.29-.3.71-.29h1.65a1 1 0 0 1 .9.58L8.53 12h7l3.62-6.5q.12-.26.35-.37.23-.13.5-.13.57 0 .86.49.3.48.02.98l-3.58 6.48A2 2 0 0 1 15.55 14H8.1L7 16h11q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29H7q-1.12 0-1.71-.98-.59-.96-.04-1.97L6.6 12.6z" />
  </svg>
)
export default SvgCartPlus
